// recuperacao-03 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Enviar notificação push": "Enviar notificación push",
};

export default catalogo;
